<template>
<div class="chapter">
<div class="inner_page">
<div class="dochead" id="pgepubid00000">
<h2 class="author" id="pgepubid00001">"The Coxswain's Bride"</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec001_split_001.vue?0a158065